import { render, staticRenderFns } from "./PreviewBettingArea.vue?vue&type=template&id=1b182c50&scoped=true"
import script from "./PreviewBettingArea.vue?vue&type=script&lang=js"
export * from "./PreviewBettingArea.vue?vue&type=script&lang=js"
import style0 from "./PreviewBettingArea.vue?vue&type=style&index=0&id=1b182c50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b182c50",
  null
  
)

export default component.exports